import { render, staticRenderFns } from "./ModalLead.vue?vue&type=template&id=2579e095&scoped=true&"
import script from "./ModalLead.vue?vue&type=script&lang=js&"
export * from "./ModalLead.vue?vue&type=script&lang=js&"
import style0 from "./ModalLead.vue?vue&type=style&index=0&id=2579e095&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2579e095",
  null
  
)

export default component.exports